export default "__VITE_ASSET__DkZXzcp7__"